import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { hasAuthData, getTokenData } from '../../helpers/authStorage';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = hasAuthData();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const tokenData = getTokenData();
  const claim = tokenData?.tenantSelected;
  const isTenantSelected = claim === true || claim === 'true';

  if (!isTenantSelected && location.pathname !== '/contexts') {
    return <Navigate to="/contexts" replace />;
  }

  return children;
}
